<mat-toolbar class="small-bar">
  <span>Datalogger config</span>
  <span class="toolbar-spacer"></span>
  <button mat-raised-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>menu</mat-icon> Menu</button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="getIP()"><mat-icon>sync</mat-icon> Get IP and Port</button>
    <button mat-menu-item (click)="getPushToServerPerios()"><mat-icon>sync</mat-icon> Get push to server period</button>
    <button mat-menu-item (click)="getUsername()"><mat-icon>sync</mat-icon> Get username</button>
    <button mat-menu-item (click)="onClickAdhocBtn()" [disabled]="!deviceData.port"><mat-icon>publish</mat-icon>AdHoc Push data</button>
  </mat-menu>
</mat-toolbar>

<div class="container-fluid my-3">
  <div class="row">
    <div class="col-md-2">
      <div class="pt-2">
        <mat-slide-toggle class="ms-2" [checked]="activeLogger > 0" color="primary" (toggleChange)="onActiveLoggerChange()">Active logger</mat-slide-toggle>
      </div>
    </div>
    <div class="col-md-3">
      <div class="pt-2">
        <mat-slide-toggle class="ms-2" [checked]="deviceData.port > 0" color="primary" (toggleChange)="onPortToggleChange()" [disabled]="!deviceData.ip || (deviceData.ip == '0.0.0.0')">Data logging on server</mat-slide-toggle>
        <span class="ms-2 text-secondary fst-italic">({{deviceData.port ? deviceData.port : 0}})</span>
      </div>
    </div>
    <div class="col-md-2">
      <mat-form-field class="w-100">
        <mat-label translate>Data server</mat-label>
        <mat-select [(ngModel)]="deviceData.ip" (ngModelChange)="onIPChange()">
          @for (server of servers; track server) {
            <mat-option [value]="server.ip">{{server.name}} ({{server.ip}}:{{server.port}})</mat-option>
          }
        </mat-select>
        <mat-hint>({{deviceData.ip ? deviceData.ip : 'N/A'}} {{deviceData.username ? deviceData.username: ''}})</mat-hint>
      </mat-form-field>
    </div>
    <div class="col-md-2">
      <mat-form-field class="w-100">
        <mat-label translate>Data push to server period (minutes)</mat-label>
        <mat-select [(ngModel)]="deviceData.push_period" (ngModelChange)="onPushPeriodChange()">
          <mat-option [value]="1">1 min</mat-option>
          <mat-option [value]="5">5 min</mat-option>
          <mat-option [value]="10">10 min</mat-option>
          <mat-option [value]="15">15 min</mat-option>
          <mat-option [value]="20">20 min</mat-option>
          <mat-option [value]="30">30 min</mat-option>
          <mat-option [value]="45">45 min</mat-option>
          <mat-option [value]="60">60 min</mat-option>
        </mat-select>
        <mat-hint>({{deviceData.push_period ? deviceData.push_period+' min' : 'N/A'}})</mat-hint>

      </mat-form-field>
    </div>
    <div class="col-md-3 text-end">
      <button mat-raised-button color="accent" (click)="writeRegisters()" [disabled]="!writeList.length"><mat-icon>publish</mat-icon> Write config</button>
      <button mat-raised-button color="accent" (click)="readRegisters()" class="ms-2"><mat-icon>file_download</mat-icon> Read config</button>
    </div>
  </div>
</div>
<mat-toolbar class="small-bar">
  <span>Measuring devices</span>
</mat-toolbar>
@if (!children || !children.length) {
  <p class="text-center p-3">No measuring devices.</p>
}
@if (children && children.length) {
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Index</th>
        <th>Target</th>
        <th>Type</th>
        <th>Name</th>
        <th>Serial number</th>
        <th>Last communication time</th>
        <th>Config</th>
        <th>Logging</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (child of children; track child) {
        <tr>
          <td>{{child.index}}</td>
          <td  class="fw-bold">{{child.target}}</td>
          <td>{{child.type && child.type.name ? child.type.name : '-'}}</td>
          <td>{{child.name}}</td>
          <td>{{child.serial}}</td>
          <td>{{child.lastcom ? child.lastcom : 'N/A'}}</td>
          <td><mat-icon>{{child.hasConfig ? 'check_box' : 'check_box_outline_blank'}}</mat-icon></td>
          <td>
            <mat-slide-toggle class="ms-2" [checked]="child.logging_period > 0" color="accent" (toggleChange)="onLoggingPeriodChange(child)" [disabled]="!device.isOnline || !child.hasConfig"></mat-slide-toggle>
          </td>
          <td><button mat-raised-button color="primary" [routerLink]="['/device', child.id]">View device</button></td>
        </tr>
      }
    </tbody>
  </table>
}
